module.exports = __webpack_public_path__ + "static/media/sell_start_service_make_4.f903f9a3.jpg";